import axiosInstance from "../Interceptor";

export const getOrdersAnalyticsApi = (data) => {
  //   console.log(data, 'from api');


  return axiosInstance
    .get(`orders/api/v1/orders/regional_admin/${data}/`)
    .then((res) => {
      // console.log(res);
      return res;
    })
    .catch((err) => {
  
      return err;
    });
};
